import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const strengthfitnessApiService = createApi({
  reducerPath: "strengthfitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createStrength: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `strengthtest/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getStrength: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `strengthtest/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateStrength: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `strengthtest/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
    getStrengthChart: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `strengthtest/chart-data${query}`;
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useCreateStrengthMutation,
  useGetStrengthQuery,
  useUpdateStrengthMutation,
  useGetStrengthChartQuery,
} = strengthfitnessApiService;
